import { processSteps } from "@/lib/site-data";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
export const HowItWorksPage = () => {
  return (
    <div className="mx-auto max-w-7xl space-y-20 px-6 pb-20 pt-16 md:px-10">

      {/* HERO */}
      <section className="space-y-6">
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]">
          How It Works
        </p>

        <h1 className="text-4xl font-bold md:text-5xl">
          A Structured Hiring Execution Framework
        </h1>

        <p className="max-w-3xl text-[#D9E1E8]/80 text-lg">
          The AI Matters platform transforms traditional hiring into a
          structured, data-driven process. Our system combines AI-powered
          candidate intelligence, recruiter collaboration, and governance
          workflows to deliver faster and higher-quality hiring outcomes.
        </p>
      </section>


      {/* PROCESS STEPS */}
      <section className="grid gap-6 md:grid-cols-2">

        {processSteps.map((step, index) => (
          <Card
            key={step}
            className="border-[#2EC4A6]/20 bg-[#0B253C]/55 p-8"
          >
            <p className="text-xs uppercase tracking-widest text-[#6FE3C1]">
              Step {index + 1}
            </p>

            <p className="mt-2 text-xl font-semibold">
              {step}
            </p>

            <p className="mt-3 text-[#D9E1E8]/80">
              This stage ensures that hiring teams and recruiter partners
              remain aligned with the role requirements while AI insights
              help prioritize the most relevant candidates in the pipeline.
            </p>
          </Card>
        ))}

      </section>


      {/* WORKFLOW EXPLANATION */}
      <section>

        <h2 className="text-3xl font-bold mb-6">
          Designed for Scalable Hiring Programs
        </h2>

        <p className="max-w-4xl text-[#D9E1E8]/80">
          Traditional hiring often relies on fragmented tools and manual
          coordination between recruiters, hiring managers, and HR teams.
          The AI Matters platform eliminates this complexity by introducing
          a unified workflow system that connects every stage of the hiring
          lifecycle.
        </p>

        <p className="mt-4 max-w-4xl text-[#D9E1E8]/80">
          From defining role requirements to candidate evaluation,
          interview coordination, and final hiring decisions, our
          platform ensures every step is structured, measurable,
          and optimized for speed and quality.
        </p>

      </section>


      {/* CTA */}
      <section className="glass-panel rounded-2xl p-10 text-center">

        <h2 className="text-3xl font-bold mb-4">
          Experience the AI Hiring Workflow
        </h2>

        <p className="max-w-2xl mx-auto text-[#D9E1E8]/80 mb-6">
          Discover how The AI Matters platform enables organizations to
          build scalable hiring programs powered by AI insights and
          recruiter collaboration.
        </p>

        <Link to="/contact">
          <button className="rounded-full bg-[#2EC4A6] px-8 py-3 font-semibold text-[#071A2C] hover:bg-[#6FE3C1]">
            Book a Platform Demo
          </button>
        </Link>

      </section>

    </div>
  );
};